import { ArrowUpRight } from "lucide-react";
import Reveal from "@/components/Reveal";
import { scrollToId } from "@/lib/scroll";

const SERVICES = [
  {
    num: "01",
    title: "Intermediación en la venta",
    desc: "¿No tienes comprador para tu empresa? Lo buscamos entre nuestra red de inversores y compradores estratégicos, negociamos en tu nombre y damos todo el asesoramiento legal y financiero hasta el cierre.",
    tag: "Trabajamos a éxito",
  },
  {
    num: "02",
    title: "Asesoramiento al vendedor",
    desc: "¿Ya tienes comprador para tu empresa? Negociamos los términos de la operación y damos todo el asesoramiento legal y financiero para que cierres con garantías.",
    tag: "Honorarios a medida",
  },
  {
    num: "03",
    title: "Valoraciones de negocio",
    desc: "Determinamos el valor real de tu empresa con metodologías contrastadas, para que negocies desde el conocimiento y tomes decisiones con rigor.",
    tag: "Valoración confidencial",
  },
  {
    num: "04",
    title: "Consultoría financiera",
    desc: "Estructura de capital, control de gestión y planificación financiera para crecer, invertir o preparar tu empresa para una venta.",
    tag: "Acompañamiento continuo",
  },
  {
    num: "05",
    title: "Planificación patrimonial y gestión de inversiones",
    desc: "Te ayudamos a planificar tu patrimonio y a gestionar tus inversiones, también después de la venta, para que tu esfuerzo tenga continuidad.",
    tag: "Visión a largo plazo",
  },
];

export default function Services() {
  return (
    <section id="servicios" data-testid="services-section" className="relative py-24 md:py-36">
      <div className="mx-auto max-w-7xl px-6 md:px-10">
        <div className="grid gap-10 md:grid-cols-12 md:items-end">
          <Reveal className="md:col-span-7">
            <p className="eyebrow">¿Qué te ofrecemos?</p>
            <h2 className="mt-6 font-serif text-4xl leading-tight text-white sm:text-5xl">
              Servicios pensados para vender bien.
            </h2>
          </Reveal>
          <Reveal delay={0.1} className="md:col-span-5">
            <p className="max-w-md text-sm leading-relaxed text-slate-300 md:ml-auto md:text-base">
              Cada operación es única. Por eso te acompañamos desde la valoración inicial hasta el día de la firma,
              con un único objetivo: que vendas con confianza.
            </p>
          </Reveal>
        </div>

        <div className="mt-16 border-b border-gold/15">
          {SERVICES.map((s, i) => (
            <Reveal key={s.num} delay={i * 0.08} testid={`service-row-${i + 1}`}>
              <a
                href="#contacto"
                data-testid={`service-row-link-${i + 1}`}
                onClick={(e) => {
                  e.preventDefault();
                  scrollToId("#contacto");
                }}
                className="group relative grid gap-4 border-t border-gold/15 px-2 py-10 transition-colors duration-300 hover:bg-gold/[0.04] md:grid-cols-12 md:items-center md:gap-6 md:px-6"
              >
                <span className="font-serif text-2xl italic text-gold/70 md:col-span-1">{s.num}</span>
                <h3 className="font-serif text-2xl text-white transition-colors duration-300 group-hover:text-gold-light md:col-span-4 md:text-3xl">
                  {s.title}
                </h3>
                <p className="text-sm leading-relaxed text-slate-300 md:col-span-4 md:text-base">{s.desc}</p>
                <div className="flex items-center gap-4 md:col-span-3 md:justify-end">
                  <span className="hidden text-right text-[11px] font-semibold uppercase tracking-[0.2em] text-gold/80 lg:inline">
                    {s.tag}
                  </span>
                  <span className="flex h-11 w-11 items-center justify-center border border-gold/40 transition-all duration-300 group-hover:bg-gold">
                    <ArrowUpRight className="h-5 w-5 text-gold transition-colors duration-300 group-hover:text-ink" />
                  </span>
                </div>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
